module.exports = __webpack_public_path__ + "static/WheatsvilleCoOp_pin-b81e4087acfef66d48a690430331e87b.png";